/**
 * Destroys the app
 * */
export const destroyPlayer = (app) => {
  try {
    const { destroy, reset, questionsApp, getCurrentItem, getActivity } = app;
    const isInline = getActivity && getActivity().rendering_type === 'inline';

    if (!isInline && getCurrentItem && !getCurrentItem()) return;
    /**
     * Destroying and resetting will allow re-rendering the embeded components
     * */
    /**
     * stop all simple feature like audio player that might be playing
     * on the background when the player exit or closes
     **/
    questionsApp &&
      questionsApp().stopAllSimpleFeatures &&
      questionsApp().stopAllSimpleFeatures();

    if (destroy) {
      destroy();
    } else if (reset) {
      reset();
    }
  } catch (error) {
    //error - silently
  }
};
